import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { useFolder } from "src/core/contexts/FolderContext";
import { Diligence, useDeleteDiligenceMutation } from "src/core/gql/graphql";
import { toast } from "src/core/hooks/use-toast";

export const useDeleteDiligence = (
  setOpen: (open: boolean) => void,
  diligence: Diligence | null,
  setDiligenceToEdit: (diligence: Diligence | null) => void
) => {
  const [deleteDiligence] = useDeleteDiligenceMutation();
  const { refetch } = useFolder();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = useCallback(async () => {
    try {
      setIsLoading(true);
      if (!diligence) {
        throw new Error("Diligence not found");
      }

      await deleteDiligence({ variables: { diligenceId: diligence.id } });
      await refetch();

      toast({
        description: t("form.deleteDiligence.modal.success"),
      });
    } catch (error) {
      console.error("useDeleteDiligence::error", error);
      toast({
        description: t("form.deleteDiligence.modal.error"),
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
      setOpen(false);
      setDiligenceToEdit(null);
    }
  }, [diligence, deleteDiligence, refetch, t, setOpen, setDiligenceToEdit]);

  return {
    handleDelete,
    isLoading,
  };
};
